import { render, staticRenderFns } from "./Wh5eAddBuy.vue?vue&type=template&id=38fe5274&scoped=true"
import script from "./Wh5eAddBuy.vue?vue&type=script&lang=js"
export * from "./Wh5eAddBuy.vue?vue&type=script&lang=js"
import style0 from "./Wh5eAddBuy.vue?vue&type=style&index=0&id=38fe5274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fe5274",
  null
  
)

export default component.exports